"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginProvider = void 0;
var _login = require("@ori/login");
var _jsxRuntime = require("react/jsx-runtime");
const LoginProvider = ({
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_login.LoginProvider, {
  children: children
});
exports.LoginProvider = LoginProvider;
